import { jsx as Z } from "react/jsx-runtime";
import { c as _e } from "../index-Cu0xwYjD.js";
import * as t from "react";
const Re = "_verificationCode_1qwr0_1", De = "_slot_1qwr0_7", Te = "_empty_1qwr0_22", Ae = "_active_1qwr0_26", J = {
  verificationCode: Re,
  slot: De,
  empty: Te,
  active: Ae
};
var We = Object.defineProperty, je = Object.defineProperties, Be = Object.getOwnPropertyDescriptors, Q = Object.getOwnPropertySymbols, he = Object.prototype.hasOwnProperty, ge = Object.prototype.propertyIsEnumerable, me = (r, l, a) => l in r ? We(r, l, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[l] = a, Oe = (r, l) => {
  for (var a in l) he.call(l, a) && me(r, a, l[a]);
  if (Q) for (var a of Q(l)) ge.call(l, a) && me(r, a, l[a]);
  return r;
}, Ie = (r, l) => je(r, Be(l)), Fe = (r, l) => {
  var a = {};
  for (var u in r) he.call(r, u) && l.indexOf(u) < 0 && (a[u] = r[u]);
  if (r != null && Q) for (var u of Q(r)) l.indexOf(u) < 0 && ge.call(r, u) && (a[u] = r[u]);
  return a;
};
function He(r) {
  let l = setTimeout(r, 0), a = setTimeout(r, 10), u = setTimeout(r, 50);
  return [l, a, u];
}
function Le(r) {
  let l = t.useRef();
  return t.useEffect(() => {
    l.current = r;
  }), l.current;
}
var Ne = 18, ve = 40, $e = `${ve}px`, qe = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function Ge({ containerRef: r, inputRef: l, pushPasswordManagerStrategy: a, isFocused: u }) {
  let [M, d] = t.useState(!1), [I, x] = t.useState(!1), [A, F] = t.useState(!1), H = t.useMemo(() => a === "none" ? !1 : (a === "increase-width" || a === "experimental-no-flickering") && M && I, [M, I, a]), W = t.useCallback(() => {
    let m = r.current, C = l.current;
    if (!m || !C || A || a === "none") return;
    let v = m, S = v.getBoundingClientRect().left + v.offsetWidth, j = v.getBoundingClientRect().top + v.offsetHeight / 2, i = S - Ne, L = j;
    document.querySelectorAll(qe).length === 0 && document.elementFromPoint(i, L) === m || (d(!0), F(!0));
  }, [r, l, A, a]);
  return t.useEffect(() => {
    let m = r.current;
    if (!m || a === "none") return;
    function C() {
      let S = window.innerWidth - m.getBoundingClientRect().right;
      x(S >= ve);
    }
    C();
    let v = setInterval(C, 1e3);
    return () => {
      clearInterval(v);
    };
  }, [r, a]), t.useEffect(() => {
    let m = u || document.activeElement === l.current;
    if (a === "none" || !m) return;
    let C = setTimeout(W, 0), v = setTimeout(W, 2e3), S = setTimeout(W, 5e3), j = setTimeout(() => {
      F(!0);
    }, 6e3);
    return () => {
      clearTimeout(C), clearTimeout(v), clearTimeout(S), clearTimeout(j);
    };
  }, [l, u, a, W]), { hasPWMBadge: M, willPushPWMBadge: H, PWM_BADGE_SPACE_WIDTH: $e };
}
var ze = t.createContext({}), be = t.forwardRef((r, l) => {
  var a = r, { value: u, onChange: M, maxLength: d, textAlign: I = "left", pattern: x, placeholder: A, inputMode: F = "numeric", onComplete: H, pushPasswordManagerStrategy: W = "increase-width", pasteTransformer: m, containerClassName: C, noScriptCSSFallback: v = Ve, render: S, children: j } = a, i = Fe(a, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), L, ne, re, le, ae;
  let [we, Se] = t.useState(typeof i.defaultValue == "string" ? i.defaultValue : ""), c = u ?? we, k = Le(c), N = t.useCallback((e) => {
    M == null || M(e), Se(e);
  }, [M]), w = t.useMemo(() => x ? typeof x == "string" ? new RegExp(x) : x : null, [x]), s = t.useRef(null), U = t.useRef(null), X = t.useRef({ value: c, onChange: N, isIOS: typeof window < "u" && ((ne = (L = window == null ? void 0 : window.CSS) == null ? void 0 : L.supports) == null ? void 0 : ne.call(L, "-webkit-touch-callout", "none")) }), V = t.useRef({ prev: [(re = s.current) == null ? void 0 : re.selectionStart, (le = s.current) == null ? void 0 : le.selectionEnd, (ae = s.current) == null ? void 0 : ae.selectionDirection] });
  t.useImperativeHandle(l, () => s.current, []), t.useEffect(() => {
    let e = s.current, n = U.current;
    if (!e || !n) return;
    X.current.value !== e.value && X.current.onChange(e.value), V.current.prev = [e.selectionStart, e.selectionEnd, e.selectionDirection];
    function p() {
      if (document.activeElement !== e) {
        q(null), G(null);
        return;
      }
      let o = e.selectionStart, f = e.selectionEnd, K = e.selectionDirection, b = e.maxLength, R = e.value, E = V.current.prev, y = -1, P = -1, D;
      if (R.length !== 0 && o !== null && f !== null) {
        let Me = o === f, xe = o === R.length && R.length < b;
        if (Me && !xe) {
          let T = o;
          if (T === 0) y = 0, P = 1, D = "forward";
          else if (T === b) y = T - 1, P = T, D = "backward";
          else if (b > 1 && R.length > 1) {
            let te = 0;
            if (E[0] !== null && E[1] !== null) {
              D = T < E[1] ? "backward" : "forward";
              let ke = E[0] === E[1] && E[0] < b;
              D === "backward" && !ke && (te = -1);
            }
            y = te + T, P = te + T + 1;
          }
        }
        y !== -1 && P !== -1 && y !== P && s.current.setSelectionRange(y, P, D);
      }
      let pe = y !== -1 ? y : o, fe = P !== -1 ? P : f, Pe = D ?? K;
      q(pe), G(fe), V.current.prev = [pe, fe, Pe];
    }
    if (document.addEventListener("selectionchange", p, { capture: !0 }), p(), document.activeElement === e && Y(!0), !document.getElementById("input-otp-style")) {
      let o = document.createElement("style");
      if (o.id = "input-otp-style", document.head.appendChild(o), o.sheet) {
        let f = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        z(o.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), z(o.sheet, `[data-input-otp]:autofill { ${f} }`), z(o.sheet, `[data-input-otp]:-webkit-autofill { ${f} }`), z(o.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), z(o.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let h = () => {
      n && n.style.setProperty("--root-height", `${e.clientHeight}px`);
    };
    h();
    let g = new ResizeObserver(h);
    return g.observe(e), () => {
      document.removeEventListener("selectionchange", p, { capture: !0 }), g.disconnect();
    };
  }, []);
  let [oe, ie] = t.useState(!1), [$, Y] = t.useState(!1), [_, q] = t.useState(null), [B, G] = t.useState(null);
  t.useEffect(() => {
    He(() => {
      var e, n, p, h;
      (e = s.current) == null || e.dispatchEvent(new Event("input"));
      let g = (n = s.current) == null ? void 0 : n.selectionStart, o = (p = s.current) == null ? void 0 : p.selectionEnd, f = (h = s.current) == null ? void 0 : h.selectionDirection;
      g !== null && o !== null && (q(g), G(o), V.current.prev = [g, o, f]);
    });
  }, [c, $]), t.useEffect(() => {
    k !== void 0 && c !== k && k.length < d && c.length === d && (H == null || H(c));
  }, [d, H, k, c]);
  let O = Ge({ containerRef: U, inputRef: s, pushPasswordManagerStrategy: W, isFocused: $ }), ue = t.useCallback((e) => {
    let n = e.currentTarget.value.slice(0, d);
    if (n.length > 0 && w && !w.test(n)) {
      e.preventDefault();
      return;
    }
    typeof k == "string" && n.length < k.length && document.dispatchEvent(new Event("selectionchange")), N(n);
  }, [d, N, k, w]), ce = t.useCallback(() => {
    var e;
    if (s.current) {
      let n = Math.min(s.current.value.length, d - 1), p = s.current.value.length;
      (e = s.current) == null || e.setSelectionRange(n, p), q(n), G(p);
    }
    Y(!0);
  }, [d]), se = t.useCallback((e) => {
    var n, p;
    let h = s.current;
    if (!m && (!X.current.isIOS || !e.clipboardData || !h)) return;
    let g = e.clipboardData.getData("text/plain"), o = m ? m(g) : g;
    e.preventDefault();
    let f = (n = s.current) == null ? void 0 : n.selectionStart, K = (p = s.current) == null ? void 0 : p.selectionEnd, b = (f !== K ? c.slice(0, f) + o + c.slice(K) : c.slice(0, f) + o + c.slice(f)).slice(0, d);
    if (b.length > 0 && w && !w.test(b)) return;
    h.value = b, N(b);
    let R = Math.min(b.length, d - 1), E = b.length;
    h.setSelectionRange(R, E), q(R), G(E);
  }, [d, N, w, c]), Ee = t.useMemo(() => ({ position: "relative", cursor: i.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [i.disabled]), de = t.useMemo(() => ({ position: "absolute", inset: 0, width: O.willPushPWMBadge ? `calc(100% + ${O.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: O.willPushPWMBadge ? `inset(0 ${O.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: I, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [O.PWM_BADGE_SPACE_WIDTH, O.willPushPWMBadge, I]), Ce = t.useMemo(() => t.createElement("input", Ie(Oe({ autoComplete: i.autoComplete || "one-time-code" }, i), { "data-input-otp": !0, "data-input-otp-placeholder-shown": c.length === 0 || void 0, "data-input-otp-mss": _, "data-input-otp-mse": B, inputMode: F, pattern: w == null ? void 0 : w.source, "aria-placeholder": A, style: de, maxLength: d, value: c, ref: s, onPaste: (e) => {
    var n;
    se(e), (n = i.onPaste) == null || n.call(i, e);
  }, onChange: ue, onMouseOver: (e) => {
    var n;
    ie(!0), (n = i.onMouseOver) == null || n.call(i, e);
  }, onMouseLeave: (e) => {
    var n;
    ie(!1), (n = i.onMouseLeave) == null || n.call(i, e);
  }, onFocus: (e) => {
    var n;
    ce(), (n = i.onFocus) == null || n.call(i, e);
  }, onBlur: (e) => {
    var n;
    Y(!1), (n = i.onBlur) == null || n.call(i, e);
  } })), [ue, ce, se, F, de, d, B, _, i, w == null ? void 0 : w.source, c]), ee = t.useMemo(() => ({ slots: Array.from({ length: d }).map((e, n) => {
    var p;
    let h = $ && _ !== null && B !== null && (_ === B && n === _ || n >= _ && n < B), g = c[n] !== void 0 ? c[n] : null, o = c[0] !== void 0 ? null : (p = A == null ? void 0 : A[n]) != null ? p : null;
    return { char: g, placeholderChar: o, isActive: h, hasFakeCaret: h && g === null };
  }), isFocused: $, isHovering: !i.disabled && oe }), [$, oe, d, B, _, i.disabled, c]), ye = t.useMemo(() => S ? S(ee) : t.createElement(ze.Provider, { value: ee }, j), [j, ee, S]);
  return t.createElement(t.Fragment, null, v !== null && t.createElement("noscript", null, t.createElement("style", null, v)), t.createElement("div", { ref: U, "data-input-otp-container": !0, style: Ee, className: C }, ye, t.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, Ce)));
});
be.displayName = "Input";
function z(r, l) {
  try {
    r.insertRule(l);
  } catch {
    console.error("input-otp could not insert CSS rule:", l);
  }
}
var Ve = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`, Ke = "^\\d+$";
const Ue = (r) => /* @__PURE__ */ Z(
  be,
  {
    maxLength: 6,
    value: r.value,
    onChange: r.onChange,
    onComplete: r.onSubmit,
    pattern: Ke,
    render: ({ slots: l }) => /* @__PURE__ */ Z("div", { className: J.verificationCode, children: l.map((a, u) => /* @__PURE__ */ Z(Ze, { index: u, slot: a }, u)) })
  }
), Ze = ({ index: r, slot: l }) => /* @__PURE__ */ Z(
  "div",
  {
    className: _e(
      J.slot,
      l.isActive && J.active,
      l.char === null && J.empty
    ),
    children: l.char
  },
  `slot-${r}`
);
export {
  Ue as VerificationCode
};
